import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import ErrorPage from '../Error';
import errorLog from '../../../utils/errorLog';
import { initLogLevel, sendErrorReport } from '../../../utils/log';

initLogLevel();

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
    const { history } = this.props;

    history.listen((location, action) => {
      if (this.state.hasError) {
        this.setState({ hasError: false });
      }
    });
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message ? error.message : error };
  }

  componentDidCatch(error, info) {
    sendErrorReport(error, info, this.props.username);
  }

  render() {
    if (this.state.hasError) {
      errorLog({ userID: this.props.username, errorMessage: this.state.errorMessage, returnPage: 'Oops something went wrong' });
      return <ErrorPage />;
    }
    return this.props.children;
  }
}

const mapStateToProps = ({ User }) => ({
  username: User.username,
});

export default withRouter(connect(mapStateToProps, null)(ErrorBoundary));
